<template>
  <div class="content-page-header">
    <h1 class="content-page-title">{{ functionName }} : {{ pageName }}</h1>
  </div>
</template>

<script>
export default {
  name: 'ContentPageHeader',
  props: {
    functionName: {
      type: String,
      required: true
    },
    pageName: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.content-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #FFF;
  padding: 20px;
  margin: 5px;
  height: 70px;
}

.content-page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
</style>
